define('models/calendar/favorite',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api',
    'services/i18n'
], function(
    _, Backbone, U,
    // services
    API,
    i18n
) {

    var MFavorite = Backbone.Model.extend({
        idAttribute: '_id',
        urlRoot: API.url('favorites/'),
        blacklist: ['user'],
        defaults: {
            name: ""
        },

        parse: function(data, opt) {
            if (data.type === 'animated-session') data = this.parseAnimated(data);
            return MFavorite.__super__.parse.call(this, data, opt);
        },

        parseAnimated: function(data) {
            data.data = _.each(data.data, function(val, key, dataObj) {
                dataObj.exercises = _.filter(dataObj.exercises, function(exerciseObj) {
                    return exerciseObj.type !== 'placeholder';
                });
            });
            return data;
        },

        getDefaultName: function() {
            switch (this.getType()) {
                case 'animated-session':
                    return i18n.t('Untitled animated session');
                case 'calendar-activity':
                    return i18n.t('Untitled activity');
                case 'nutrilog':
                    return i18n.t('Untitled nutrilog');
            }
        },

        getType: function() {
            return this.get('type');
        },

        isAnimated: function() {
            return this.getType() === 'animated-session';
        },

        // urlRoot: function() {
        //     return API.url('favorites/' + this.get('type'));
        // },
    });

    return MFavorite;
});

